import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;
export const AFFILIATE_URL = process.env.REACT_APP_AFFILIATE_URL || "#";

export const http = axios.create({ baseURL: API, withCredentials: true });

http.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("mareia_admin_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function errText(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Error";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").join(" ");
  return String(d);
}
